
export default {
  name: "Label",
  props: {
    color: {
      type: String,
      default: '#d32007',
      required: false,
    }
  }
}
